(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[397],{

/***/ 33162:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  bufferToHex: () => (/* binding */ bufferToHex),
  decodeBase64: () => (/* binding */ decodeBase64),
  encodeBase64: () => (/* binding */ encodeBase64),
  randomString: () => (/* binding */ randomString),
  sha256: () => (/* binding */ sha256)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(26368);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.to-string.js
var es_error_to_string = __webpack_require__(86011);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__(45942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__(50009);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(8946);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__(21402);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.btoa.js
var web_btoa = __webpack_require__(349);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-exception.constructor.js
var web_dom_exception_constructor = __webpack_require__(23714);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-exception.stack.js
var web_dom_exception_stack = __webpack_require__(56469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-exception.to-string-tag.js
var web_dom_exception_to_string_tag = __webpack_require__(17810);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.atob.js
var web_atob = __webpack_require__(22219);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(23184);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.at.js
var es_typed_array_at = __webpack_require__(96067);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92232);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(98147);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(26250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(20482);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(53845);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(44473);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.find-last.js
var es_typed_array_find_last = __webpack_require__(69643);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.find-last-index.js
var es_typed_array_find_last_index = __webpack_require__(6987);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(48069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(64096);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(52133);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(34658);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(20280);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(13253);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(64960);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(74771);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(82462);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(48250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(1003);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(71662);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(90904);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(19911);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(74696);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(43596);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.to-reversed.js
var es_typed_array_to_reversed = __webpack_require__(55483);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.to-sorted.js
var es_typed_array_to_sorted = __webpack_require__(76895);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(69745);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.typed-array.with.js
var es_typed_array_with = __webpack_require__(95315);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array-buffer.slice.js
var es_array_buffer_slice = __webpack_require__(43601);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@smithy+util-utf8@2.0.2/node_modules/@smithy/util-utf8/dist-es/fromUtf8.browser.js
var fromUtf8_browser = __webpack_require__(47268);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+util@5.2.0/node_modules/@aws-crypto/util/build/module/convertToBuffer.js
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from
    ? function (input) { return Buffer.from(input, "utf8"); }
    : fromUtf8_browser/* fromUtf8 */.$;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array)
        return data;
    if (typeof data === "string") {
        return fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
//# sourceMappingURL=convertToBuffer.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+util@5.2.0/node_modules/@aws-crypto/util/build/module/isEmptyData.js
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
//# sourceMappingURL=isEmptyData.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+util@5.2.0/node_modules/@aws-crypto/util/build/module/index.js
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-browser@5.2.0/node_modules/@aws-crypto/sha256-browser/build/module/constants.js
var SHA_256_HASH = { name: "SHA-256" };
var SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: SHA_256_HASH
};
var EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-sdk+util-locate-window@3.465.0/node_modules/@aws-sdk/util-locate-window/dist-es/index.js
const fallbackWindow = {};
function locateWindow() {
    if (typeof window !== "undefined") {
        return window;
    }
    else if (typeof self !== "undefined") {
        return self;
    }
    return fallbackWindow;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-browser@5.2.0/node_modules/@aws-crypto/sha256-browser/build/module/webCryptoSha256.js



var webCryptoSha256_Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function (data) {
        if (isEmptyData(data)) {
            return;
        }
        var update = convertToBuffer(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function () {
        var _this = this;
        if (this.key) {
            return this.key.then(function (key) {
                return locateWindow()
                    .crypto.subtle.sign(SHA_256_HMAC_ALGO, key, _this.toHash)
                    .then(function (data) { return new Uint8Array(data); });
            });
        }
        if (isEmptyData(this.toHash)) {
            return Promise.resolve(EMPTY_DATA_SHA_256);
        }
        return Promise.resolve()
            .then(function () {
            return locateWindow().crypto.subtle.digest(SHA_256_HASH, _this.toHash);
        })
            .then(function (data) { return Promise.resolve(new Uint8Array(data)); });
    };
    Sha256.prototype.reset = function () {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function (resolve, reject) {
                locateWindow()
                    .crypto.subtle.importKey("raw", convertToBuffer(_this.secret), SHA_256_HMAC_ALGO, false, ["sign"])
                    .then(resolve, reject);
            });
            this.key.catch(function () { });
        }
    };
    return Sha256;
}());

//# sourceMappingURL=webCryptoSha256.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43112);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-js@5.2.0/node_modules/@aws-crypto/sha256-js/build/module/constants.js
/**
 * @internal
 */
var BLOCK_SIZE = 64;
/**
 * @internal
 */
var DIGEST_LENGTH = 32;
/**
 * @internal
 */
var KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */
var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */
var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-js@5.2.0/node_modules/@aws-crypto/sha256-js/build/module/RawSha256.js

/**
 * @internal
 */
var RawSha256 = /** @class */ (function () {
    function RawSha256() {
        this.state = Int32Array.from(INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */
        this.finished = false;
    }
    RawSha256.prototype.update = function (data) {
        if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
        }
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
        }
        while (byteLength > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function () {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
                for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
                    bufferView.setUint8(i, 0);
                }
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
                bufferView.setUint8(i, 0);
            }
            bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(DIGEST_LENGTH);
        for (var i = 0; i < 8; i++) {
            out[i * 4] = (this.state[i] >>> 24) & 0xff;
            out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
            out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
            out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function () {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for (var i = 0; i < BLOCK_SIZE; i++) {
            if (i < 16) {
                this.temp[i] =
                    ((buffer[i * 4] & 0xff) << 24) |
                        ((buffer[i * 4 + 1] & 0xff) << 16) |
                        ((buffer[i * 4 + 2] & 0xff) << 8) |
                        (buffer[i * 4 + 3] & 0xff);
            }
            else {
                var u = this.temp[i - 2];
                var t1_1 = ((u >>> 17) | (u << 15)) ^ ((u >>> 19) | (u << 13)) ^ (u >>> 10);
                u = this.temp[i - 15];
                var t2_1 = ((u >>> 7) | (u << 25)) ^ ((u >>> 18) | (u << 14)) ^ (u >>> 3);
                this.temp[i] =
                    ((t1_1 + this.temp[i - 7]) | 0) + ((t2_1 + this.temp[i - 16]) | 0);
            }
            var t1 = ((((((state4 >>> 6) | (state4 << 26)) ^
                ((state4 >>> 11) | (state4 << 21)) ^
                ((state4 >>> 25) | (state4 << 7))) +
                ((state4 & state5) ^ (~state4 & state6))) |
                0) +
                ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) |
                0;
            var t2 = ((((state0 >>> 2) | (state0 << 30)) ^
                ((state0 >>> 13) | (state0 << 19)) ^
                ((state0 >>> 22) | (state0 << 10))) +
                ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) |
                0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = (state3 + t1) | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = (t1 + t2) | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}());

//# sourceMappingURL=RawSha256.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-js@5.2.0/node_modules/@aws-crypto/sha256-js/build/module/jsSha256.js




var jsSha256_Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new RawSha256();
        this.reset();
    }
    Sha256.prototype.update = function (toHash) {
        if (isEmptyData(toHash) || this.error) {
            return;
        }
        try {
            this.hash.update(convertToBuffer(toHash));
        }
        catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */
    Sha256.prototype.digestSync = function () {
        if (this.error) {
            throw this.error;
        }
        if (this.outer) {
            if (!this.outer.finished) {
                this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */
    Sha256.prototype.digest = function () {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                return [2 /*return*/, this.digestSync()];
            });
        });
    };
    Sha256.prototype.reset = function () {
        this.hash = new RawSha256();
        if (this.secret) {
            this.outer = new RawSha256();
            var inner = bufferFromSecret(this.secret);
            var outer = new Uint8Array(BLOCK_SIZE);
            outer.set(inner);
            for (var i = 0; i < BLOCK_SIZE; i++) {
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for (var i = 0; i < inner.byteLength; i++) {
                inner[i] = 0;
            }
        }
    };
    return Sha256;
}());

function bufferFromSecret(secret) {
    var input = convertToBuffer(secret);
    if (input.byteLength > BLOCK_SIZE) {
        var bufferHash = new RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
//# sourceMappingURL=jsSha256.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-js@5.2.0/node_modules/@aws-crypto/sha256-js/build/module/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+supports-web-crypto@5.2.0/node_modules/@aws-crypto/supports-web-crypto/build/module/supportsWebCrypto.js

var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) &&
        typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
function supportsSubtleCrypto(subtle) {
    return (subtle &&
        subtleCryptoMethods.every(function (methodName) { return typeof subtle[methodName] === "function"; }));
}
function supportsZeroByteGCM(subtle) {
    return __awaiter(this, void 0, void 0, function () {
        var key, zeroByteAuthTag, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!supportsSubtleCrypto(subtle))
                        return [2 /*return*/, false];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
                case 2:
                    key = _b.sent();
                    return [4 /*yield*/, subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [2 /*return*/, zeroByteAuthTag.byteLength === 16];
                case 4:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=supportsWebCrypto.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-browser@5.2.0/node_modules/@aws-crypto/sha256-browser/build/module/crossPlatformSha256.js





var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if (supportsWebCrypto(locateWindow())) {
            this.hash = new webCryptoSha256_Sha256(secret);
        }
        else {
            this.hash = new jsSha256_Sha256(secret);
        }
    }
    Sha256.prototype.update = function (data, encoding) {
        this.hash.update(convertToBuffer(data));
    };
    Sha256.prototype.digest = function () {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function () {
        this.hash.reset();
    };
    return Sha256;
}());

//# sourceMappingURL=crossPlatformSha256.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@aws-crypto+sha256-browser@5.2.0/node_modules/@aws-crypto/sha256-browser/build/module/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./local_modules/crypto-helpers/client.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}




















































// sha256
var sha256 = function() {
    var _ref = _async_to_generator(function(data) {
        var hash, buffer;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    hash = new Sha256();
                    hash.update(data, "utf8");
                    return [
                        4,
                        hash.digest()
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        bufferToHex(buffer)
                    ];
            }
        });
    });
    return function sha256(data) {
        return _ref.apply(this, arguments);
    };
}();
var bufferToHex = function(buffer) {
    return Array.from(buffer).map(function(b) {
        return b.toString(16).padStart(2, "0");
    }).join("");
};
// base64
var percentToByte = function(p) {
    return String.fromCharCode(parseInt(p.slice(1), 16));
};
var encodeBase64 = function(data) {
    return window.btoa(encodeURIComponent(data).replace(/%[0-9A-F]{2}/g, percentToByte));
};
var byteToPercent = function(b) {
    return "%".concat("00".concat(b.charCodeAt(0).toString(16)).slice(-2));
};
var decodeBase64 = function(data) {
    return decodeURIComponent(Array.from(window.atob(data), byteToPercent).join(""));
};
// others
var randomString = function(length) {
    var array = new Uint8Array(Math.ceil(length / 2));
    window.crypto.getRandomValues(array);
    return bufferToHex(array).substring(0, length);
};


/***/ }),

/***/ 45457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports =  true ? __webpack_require__(33162) : 0;


/***/ })

}]);